export enum EnumLocationCategories {
    Car = "Car",
    Engineer = "Engineer",
    Service = "Services",
    Location = "Location",
    Unit = "Unit",
    Warehouse = "Warehouse"
}

export enum EnumLocationCategoriesSpanish {
    Car = "General",
    Engineer = "Ingenieros",
    Service = "Servicios",
    Location = "Ubicaciones",
    Unit = "Unidades",
    Warehouse = "Almacenes"
}